import type { Lesson } from '../../schema.js';

export const SKEWER_LESSONS: Lesson[] = [
  {
    id: 'puzzle-skewer',
    slug: 'puzzles-skewer',
    title: 'Skewer attack',
    audienceLevel: 'beginner',
    concepts: ['puzzles'],
    steps: [
      {
        kind: 'explain',
        title: 'The reverse pin',
        body: 'A skewer checks the king in front, and the piece hiding BEHIND the king is the real prize. The king must move out of check, leaving the piece behind to be captured.',
        narration: 'Check the king, then grab what is behind it.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The queen behind',
        body: 'Check the black king along the diagonal and win the queen behind it.',
        fen: '8/6q1/8/4k3/8/8/8/2B4K w - - 0 1',
        answer: ['Bb2+'],
        solution: ['Bb2+', 'Ke4', 'Bxg7'],
        expect: 'win-material',
        tier: 2,
        hint: 'Check the king on the a1-h8 diagonal.',
        hintLadder: ['Check the king on the a1-h8 diagonal.', 'The black queen sits behind the king on the same line.', 'Bb2+ then Bxg7 wins the queen!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The rook behind',
        body: 'Check the king along the a-file and win the rook behind it.',
        fen: '3k3r/8/8/8/8/8/R7/6K1 w - - 0 1',
        answer: ['Ra8+'],
        solution: ['Ra8+', 'Ke7', 'Rxh8'],
        expect: 'win-material',
        tier: 2,
        hint: 'The king and rook share the a-file.',
        hintLadder: ['The king and rook share the a-file.', 'Your rook checks from a8.', 'Ra8+ then Rxh8 wins the rook!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The queen skewer',
        body: 'Your queen checks the king and wins the rook behind it.',
        fen: '2k4r/8/8/8/Q7/8/8/K7 w - - 0 1',
        answer: ['Qa8+'],
        solution: ['Qa8+', 'Kc7', 'Qxh8'],
        expect: 'win-material',
        tier: 3,
        hint: 'The king and rook share the a-file again.',
        hintLadder: ['The king and rook share the a-file again.', 'Check from a8 with your queen.', 'Qa8+ then Qxh8 wins the rook!'],
      },
    ],
  },
];
